import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import server from 'server/serverController2';
import { UserInfoActions } from 'store/actionCreators';

import Presenter from 'components/presenters/signup/ConfirmNotificationScene';
import { getQueryStringObject } from 'utils/utils'
export default function ConfirmNotificationScene() {
    const queryString = getQueryStringObject();
    const userInfo = useSelector((state) => {
        return state.userInfo;
    })

    const history = useHistory();

    const handleSubmit = () => {
        const body = {};
        body['task_like'] = true;
        body['task_comment'] = true;
        body['task_comment_reply'] = true;
        body['community_post_new'] = true;
        body['community_post_like'] = true;
        body['community_post_comment'] = true;
        body['community_post_comment_reply'] = true;
        body['task_alarm'] = true;
        body['new_challenge'] = true;
        body['new_event'] = true;
        body['marketing_info'] = true;
        server.putRequestData(`users/push/config`, body, (res) => {
            if(res.success !== 1)
            {
                return;
            }
            let redirectPath = queryString?.redirect_path
            if(redirectPath)
            {
                history.replace(redirectPath);
            }
            else
            {
                history.replace('/');
            }
        });
    }
    const handleDeny= () => {
        let redirectPath = queryString?.redirect_path;
        if(redirectPath)
        {
            history.replace(redirectPath);
        }
        else
        {
            history.replace('/');
        }
    }

    return (
        <ConfirmNotificationWrapper>
            <Presenter 
                onSubmit={handleSubmit}
                onDeny={handleDeny}
            />
        </ConfirmNotificationWrapper>
    )
}

const ConfirmNotificationWrapper = styled.div`
    height: 100%;
    background-color: #F7F7F7;
`;